<template>
  <section
    class="component-d2255999"
    resmed-component-name="popular-related-articles"
    v-if="acf.items.length"
  >
    <div class="component">
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="headings text-center">
              <slot></slot>
              <h2>{{ heading }}</h2>
            </div>
          </div>
        </div>
      </div>

      <div style="overflow: hidden" class="swiper-wrapper">
        <div class="swiper container">
          <div class="row">
            <div class="col p-0">
              <div class="seek">
                <div
                  class="seek-wrapper"
                  v-show="
                    (['md'].includes($root.mode) && acf.items.length > 2) ||
                    (['lg', 'xl'].includes($root.mode) && acf.items.length > 3)
                  "
                >
                  <a
                    ref="swiperButtonPrev"
                    href="#"
                    class="btn navigation-icon left-caret swiper-button-prev"
                  ></a>
                  <a
                    ref="swiperButtonNext"
                    href="#"
                    class="btn navigation-icon right-caret swiper-button-next"
                  ></a>
                </div>

                <div
                  ref="swiperContainer"
                  class="stage swiper-container slider"
                  v-bind:class="`-mode-${[$root.mode]}`"
                >
                  <div
                    class="items swiper-wrapper"
                    v-bind:class="{
                      '-justify-content-center': acf.items.length < 3,
                    }"
                  >
                    <div
                      class="item swiper-slide mb-3 mb-md-0"
                      v-for="(item, index) in items"
                    >
                      <div class="card">
                        <div class="content">
                          <a v-bind:href="item.permalink">
                            <h3 v-html="item.post_title"></h3>
                          </a>
                          <div class="meta">
                            <!-- <ratings
                              v-bind:type="'blog-post'"
                              v-bind:id="item.ID.toString()"
                            ></ratings> -->
                            <p class="excerpt">{{ item.post_excerpt }}</p>
                            <!-- <div class="tags">
                                                            <a v-for="(tag, index) in item.tags" v-bind:href="`${address}?tags=${Object.keys(tag)[0]}`">{{ tag[Object.keys(tag)[0]] }} <span></span></a>
                                                        </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="row"
            v-show="
              (['xs', 'sm'].includes($root.mode) && acf.items.length > 1) ||
              ($root.mode === 'md' && acf.items.length > 2) ||
              (['lg', 'xl'].includes($root.mode) && acf.items.length > 3)
            "
          >
            <div class="col">
              <div ref="swiperPagination" class="swiper-pagination"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import helper from "../../mixins/swiper-helper";

export default {
  name: "component-d2255999", // popular-related-articles
  props: ["acf", "heading"],
  data() {
    return {
      slider: undefined,
      address: "/sleep-apnea/sleep-blog/",
      items: this.acf.items.slice(0, 6),
      ids: this.acf.items.map((a) => a.ID),
    };
  },
  mixins: [helper],
  mounted() {
    this.$nextTick(() => this.swhReload());
  },
  methods: {
    swhCreate() {
      this.slider = new swiper(this.$refs.swiperContainer, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        freeMode: false,
        freeModeSticky: true,
        breakpoints: {
          768: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },

          992: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
        },
        pagination: {
          el: this.$refs.swiperPagination,
          clickable: true,
        },
        navigation: {
          nextEl: this.$refs.swiperButtonNext,
          prevEl: this.$refs.swiperButtonPrev,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";
@import "../../css/layout/sleep-blog";

.component-d2255999 {
  padding: 6rem 0 4rem 0;
  background-color: #e3eaef;
}

.component {
  h2 {
    position: relative;
    margin-bottom: 1.25rem;

    @extend %eyebrow-center;
  }

  .stage {
    .items {
      display: flex;
      align-items: stretch;
      position: relative;
      width: 100%;
      height: 100%;
      z-index: 1;

      &.-justify-content-center {
        @media (min-width: 992px) {
          justify-content: center;
        }
      }
    }

    .item {
      display: flex;
      flex-shrink: 0;
      align-items: stretch;

      padding: 0 0.725rem;
      width: 33.33%;
    }

    .card {
      @extend %cards-sleep-blog;

      &:hover {
        h3 {
          color: $cc-resmed-pulse-blue;
        }
      }
    }
  }

  @media (max-width: 767px) {
    .overflow {
      display: none;
    }
  }

  @media (max-width: 991px) {
    .swiper {
      max-width: none;
      width: 90vw !important;
    }
  }

  .seek-wrapper {
    position: absolute;
    z-index: 1;

    width: 30%;
    bottom: -42px;
    left: 50%;
    transform: translateX(-50%);

    @media (min-width: 992px) {
      width: 20%;
    }

    @media (min-width: 1306px) {
      width: 100%;
      bottom: auto;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    a:nth-child(1) {
      float: left;
      transform: translateX(-4rem) scale(1.4);
    }

    a:nth-child(2) {
      float: right;
      transform: translateX(4rem) scale(1.4);
    }
  }

  .-mode-md,
  .-mode-lg,
  .-mode-xl {
    &.swiper-container {
      position: relative;
      width: 100%;
      height: 100%;

      overflow: hidden;
      padding: 1rem 0 2rem 0;
      margin: 0 auto;
      z-index: 1;
    }
  }
}
.excerpt {
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 500;
}
</style>
